import React, { useEffect, useState } from 'react';
import { useGym } from '../../DataStore/Gym/GymContext';
import { Link } from 'react-router-dom';

const NewGymSession = ({ handleStart }) => {
  const { getScheduledClasses, scheduledClasses } = useGym();

  useEffect(() => {
    getScheduledClasses();
  }, []);

  const today = new Date().getDay();
  const formattedDay = today === 0 ? 7 : today;

  const todayClasses = Array.isArray(scheduledClasses)
    ? scheduledClasses.filter(cls => parseInt(cls.day_of_week) === formattedDay)
    : [];

  

  return (
    <div className="main-card mb-3 card p-2">
      <div className="card-header card-title">Gym Scheduler
            <div className="btn-actions-pane-right actions-icon-btn">
                  <Link to="#" className='btn-pill btn btn-outline-primary btn-sm'>New Schedule</Link>
              </div>
        </div>
        <div className="card-body">

      <div className="row" style={{ height: 'calc(100% - 150px)' }}>
        <div className="col-md-4 d-flex flex-column align-items-center justify-content-start">
          <div className="w-100 d-flex flex-column align-items-center">
            <div className="text-center mb-3">
              <h3 className="mb-0 text-success font-weight-bold">{todayClasses.length}</h3>
              <small className="text-muted">Classes Today</small>
            </div>
            <div className="text-center">
              <h3 className="mb-0 text-primary font-weight-bold">{Array.isArray(scheduledClasses) ? scheduledClasses.length : 0}</h3>
              <small className="text-muted">Total Scheduled</small>
            </div>
          </div>
        </div>

        <div className="col-md-8 pl-md-1 p-0">
          <h6 className="text-muted font-weight-normal mb-2">Upcoming Gym Classes</h6>
          <div className="overflow-auto" style={{ maxHeight: '220px' }}>
            {Array.isArray(scheduledClasses) && scheduledClasses.length > 0 ? scheduledClasses.map((cls) => (
              <div
                key={cls.id}
                className="p-3 mb-3 rounded bg-light d-flex justify-content-between align-items-center shadow-sm border"
              >
                <div>
                  <strong className="text-dark h6 mb-1 d-block">{cls.class.class_name}</strong>
                  <small className="text-muted">{cls.day_of_week_name}, {cls.scheduled_time}</small>
                </div>
                <span className="badge badge-pill badge-warning px-2 py-2" style={{ fontSize: '0.6rem' }}>
                  {cls.status.toUpperCase()}
                </span>
              </div>
            )) : (
              <div className="text-muted text-center">No scheduled classes</div>
            )}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default NewGymSession;